<template>
  <figure v-on:click="$emit('click')" class="image">
    <img
      v-bind:src="album.cover.url2x"
      v-bind:srcset="`${album.cover.url}, ${album.cover.url2x} 2x, ${album.cover.url3x} 3x`"
      v-bind:class="[isSmall ? 'poly-rounded-small' : 'poly-rounded']"
      v-on:click="$emit('cover-click')"
      loading="lazy"
      class="poly-shadow"
    >
      <slot/>
    </img>
  </figure>
</template>

<script>
  export default {
    name: 'AlbumCover',
    props: {
      album: {
        type: Object,
        required: true
      },
      isSmall: {
        type: Boolean,
        require: false,
        default: false
      }
    }
  }
</script>
